import React from 'react';
import componentServices from '../componentServices';

import AdminEmployees from './adminEmployees';
import EmployeeEdit from './employeeEdit';

const AdminModule = ({ children }) => {
	return children;
};

function isAdminOrCurrentEmployee({ securityContext, next }) {
	return securityContext.isAdminOrCurrentEmployee(next.params?.employeekey);
}

componentServices.router.addRoutes([{
	path: '/system-admin/employee',
	contentClass: 'docs',
	component: ({ ...props }) => <AdminModule { ...props}><AdminEmployees emptyTitle = "No Employees"/></AdminModule>,
	onEnter: componentServices.router.requireUser(componentServices.router.requireModule('system-admin'))
}, {
	path: '/system-admin/employee/:employeekey',
	component: ({ ...props }) => <AdminModule { ...props}><EmployeeEdit key={ componentServices.routeParams.employeekey } /></AdminModule>,
	onEnter: componentServices.router.requireUser(isAdminOrCurrentEmployee)
}, {
	path: '/system-admin',
	onEnter: ({ replace }) => {
		replace('/system-admin/employee');
		// cancel the route transition
		return false;
	}
}]);

export default AdminModule;